var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsString, IsUUID, ValidateNested } from 'class-validator';
import { HubSpotQuestionFullSizeDto } from './hubspot-question.full-size.dto.js';
export class HubSpotQuestionOptionFullSizeDto {
    id;
    createdAt;
    updatedAt;
    option;
    questionId;
    question;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], HubSpotQuestionOptionFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], HubSpotQuestionOptionFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], HubSpotQuestionOptionFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], HubSpotQuestionOptionFullSizeDto.prototype, "option", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], HubSpotQuestionOptionFullSizeDto.prototype, "questionId", void 0);
__decorate([
    Expose(),
    ValidateNested(),
    Type(() => HubSpotQuestionFullSizeDto),
    __metadata("design:type", HubSpotQuestionFullSizeDto)
], HubSpotQuestionOptionFullSizeDto.prototype, "question", void 0);
//# sourceMappingURL=hubspot-question-option.full-size.dto.js.map